<template>
  <v-list class="p-5 space-y-5">
    <v-list-subheader
      v-if="subheader"
      class="text-body-xs min-h-min -mb-2 text-[#9AA1AB] bg-transparent"
      :title="subheader"
    />

    <slot name="actions" />

    <slot />

    <template v-if="overview">
      <v-divider
        class="max-lg:hidden border-black-8"
        style="--v-border-opacity: 1"
      />
      <header-menu-link v-bind="overview" />
    </template>
  </v-list>
</template>

<script setup lang="ts">
defineProps<{
  subheader?: string
  overview?: {
    title: string
    [key: string]: string
  }
}>()
</script>

<style scoped lang="scss">
.v-list-subheader {
  --indent-padding: 0;
}
</style>
